import React from 'react'

export default function UserInvoiceStructure({ invoiceData }) {
    return (
        <>
            <div className="flex flex-col p-4 sm:p-10 bg-white shadow-md rounded-xl dark:bg-neutral-800">
                {/* Grid */}
                <div className="flex justify-between">
                    <div>
                        <img
                            src="https://cdn.shopify.com/s/files/1/0704/6378/2946/files/logo.png?v=1730407337"
                            className="w-[12rem]"
                            alt="logo"
                        />
                    </div>
                    <div className="text-end">
                        <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 dark:text-neutral-200">
                            Invoice #{invoiceData.invoiceNumber}
                        </h2>
                        <span className="mt-1 block text-gray-500 dark:text-neutral-500">
                            {invoiceData.date}
                        </span>
                        <address className="mt-4 text-end not-italic text-gray-800 dark:text-neutral-200 max-w-[10rem] ml-auto">
                            {invoiceData.companyInfo.address}
                        </address>
                    </div>
                </div>
                {/* End Grid */}

                {/* Bill To */}
                <div className="mt-8 grid sm:grid-cols-2 gap-3">
                    <div>
                        <h3 className="text-lg font-semibold text-gray-800 dark:text-neutral-200">
                            Bill to:
                        </h3>
                        <h3 className="text-lg font-semibold text-gray-800 dark:text-neutral-200">
                            {invoiceData.billTo.name}
                        </h3>
                        <address className="mt-2 not-italic text-gray-500 dark:text-neutral-500">
                            {invoiceData.billTo.address}
                        </address>
                    </div>

                    <div className="sm:text-end space-y-2">
                        <div className="grid grid-cols-2 sm:grid-cols-1 gap-3 sm:gap-2">
                            <dl className="grid sm:grid-cols-5 gap-x-3">
                                <dt className="col-span-3 font-semibold text-gray-800 dark:text-neutral-200">
                                    Invoice date:
                                </dt>
                                <dd className="col-span-2 text-gray-500 dark:text-neutral-500">
                                    {invoiceData.date}
                                </dd>
                            </dl>
                            <dl className="grid sm:grid-cols-5 gap-x-3">
                                <dt className="col-span-3 font-semibold text-gray-800 dark:text-neutral-200">
                                    Due date:
                                </dt>
                                <dd className="col-span-2 text-gray-500 dark:text-neutral-500">
                                    {invoiceData.dueDate}
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>

                {/* Table */}
                <div className="mt-6">
                    <div className="border border-gray-200 p-4 rounded-lg space-y-4 dark:border-neutral-700">
                        <div className="hidden sm:grid sm:grid-cols-5">
                            <div className="sm:col-span-2 text-xs font-medium text-gray-500 uppercase dark:text-neutral-500">
                                Item
                            </div>
                            <div className="text-start text-xs font-medium text-gray-500 uppercase dark:text-neutral-500">
                                Qty
                            </div>
                            <div className="text-start text-xs font-medium text-gray-500 uppercase dark:text-neutral-500">
                                Rate
                            </div>
                            <div className="text-end text-xs font-medium text-gray-500 uppercase dark:text-neutral-500">
                                Amount
                            </div>
                        </div>
                        <div className="hidden sm:block border-b border-gray-200 dark:border-neutral-700" />

                        {invoiceData.items.map((item, index) => (
                            <div key={index} className="grid grid-cols-3 sm:grid-cols-5 gap-2">
                                <div className="col-span-full sm:col-span-2">
                                    <h5 className="sm:hidden text-xs font-medium text-gray-500 uppercase dark:text-neutral-500">
                                        Item
                                    </h5>
                                    <p className="font-medium text-gray-800 dark:text-neutral-200">
                                        {item.description}
                                    </p>
                                </div>
                                <div>
                                    <h5 className="sm:hidden text-xs font-medium text-gray-500 uppercase dark:text-neutral-500">
                                        Qty
                                    </h5>
                                    <p className="text-gray-800 dark:text-neutral-200">{item.qty}</p>
                                </div>
                                <div>
                                    <h5 className="sm:hidden text-xs font-medium text-gray-500 uppercase dark:text-neutral-500">
                                        Rate
                                    </h5>
                                    <p className="text-gray-800 dark:text-neutral-200">{item.rate}</p>
                                </div>
                                <div>
                                    <h5 className="sm:hidden text-xs font-medium text-gray-500 uppercase dark:text-neutral-500">
                                        Amount
                                    </h5>
                                    <p className="sm:text-end text-gray-800 dark:text-neutral-200">
                                        ${item.amount}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Summary */}
                <div className="mt-8 flex sm:justify-end">
                    <div className="w-full max-w-2xl sm:text-end space-y-2">
                        <div className="grid grid-cols-2 sm:grid-cols-1 gap-3 sm:gap-2">
                            <dl className="grid sm:grid-cols-5 gap-x-3">
                                <dt className="col-span-3 font-semibold text-gray-800 dark:text-neutral-200">
                                    Subtotal:
                                </dt>
                                <dd className="col-span-2 text-gray-500 dark:text-neutral-500">
                                    ${invoiceData.subtotal}
                                </dd>
                            </dl>
                            <dl className="grid sm:grid-cols-5 gap-x-3">
                                <dt className="col-span-3 font-semibold text-gray-800 dark:text-neutral-200">
                                    Total:
                                </dt>
                                <dd className="col-span-2 text-gray-500 dark:text-neutral-500">
                                    ${invoiceData.total}
                                </dd>
                            </dl>
                            <dl className="grid sm:grid-cols-5 gap-x-3">
                                <dt className="col-span-3 font-semibold text-gray-800 dark:text-neutral-200">
                                    Tax:
                                </dt>
                                <dd className="col-span-2 text-gray-500 dark:text-neutral-500">
                                    ${invoiceData.tax}
                                </dd>
                            </dl>
                            <dl className="grid sm:grid-cols-5 gap-x-3">
                                <dt className="col-span-3 font-semibold text-gray-800 dark:text-neutral-200">
                                    Amount paid:
                                </dt>
                                <dd className="col-span-2 text-gray-500 dark:text-neutral-500">
                                    ${invoiceData.amountPaid}
                                </dd>
                            </dl>
                            <dl className="grid sm:grid-cols-5 gap-x-3">
                                <dt className="col-span-3 font-semibold text-gray-800 dark:text-neutral-200">
                                    Due balance:
                                </dt>
                                <dd className="col-span-2 text-gray-500 dark:text-neutral-500">
                                    ${invoiceData.dueBalance}
                                </dd>
                            </dl>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="mt-8 sm:mt-12 flex justify-between items-center">
                    <div className="s">
                        <h4 className="text-lg font-semibold text-gray-800 dark:text-neutral-200">
                            Thank you!
                        </h4>
                        <p className="text-gray-500 dark:text-neutral-500">
                            If you have any questions concerning this invoice, use the following
                            contact information:
                        </p>
                    </div>
                    <div className="mt-2">
                        <p className="block text-sm font-medium text-gray-800 dark:text-neutral-200">
                            masjidhub.com
                        </p>
                        <p className="block text-sm font-medium text-gray-800 dark:text-neutral-200">
                            +92 324 1234567
                        </p>
                    </div>
                </div>
                <p className="mt-5 text-sm text-gray-500 dark:text-neutral-500">
                    © 2024 MasjidHub.
                </p>
            </div>
        </>
    )
}
